export {
  Slot,
  Slottable,
  //
  Root,
  createSlot,
  createSlottable,
} from './slot';
export type { SlotProps } from './slot';
